<template>
  <div class="dashboard">
    <h3>2D Cellular Automata</h3>
    <TwoDimCanvas :width="width" :height="height"></TwoDimCanvas>
    <small id="age">{{automaton.age}}</small>
    <el-button-group>
      <el-button @click="init" style="width: 80px;">Init</el-button>
      <el-button @click="run" v-if="!running"
                 icon="el-icon-caret-right"
                 style="width: 100px">Run</el-button>
      <el-button @click="stop" v-if="!!running"
                 icon="el-icon-close"
                 style="width: 100px">Stop</el-button>
    </el-button-group>

    <el-form style="padding-top: 10px;">
      <el-form-item>
        <el-input  class="code"
                   type="textarea"
                   v-model="config.program" :rows="8"></el-input>
        <el-button @click="setRule">Set Rule</el-button>
      </el-form-item>
      <el-form-item>
        <el-slider v-model="config.density"
                   :min="0" :max="1" :step="0.01"
                   label="Density"
                   ></el-slider>
      </el-form-item>
      <el-form-item label="Color">
        <el-col :span="5">
          <el-color-picker v-model="config.aliveColor"></el-color-picker>
        </el-col>
        <el-col :span="1">
          <el-color-picker v-model="config.deadColor"></el-color-picker>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
  <!-- LIFEGAME
NEIGHBORS SUM
C IF
  DUP 2 =
  SWAP 3 =
  OR
ELSE
  3 =
THEN
 -->
</template>

<script>
import { TwoDimCellularAutomaton } from '@/ca'
import TwoDimCanvas from '@/components/TwoDimCanvas'
export default {
  components: {
    TwoDimCanvas
  },
  data () {
    return {
      width: 600,
      height: 300,
      automaton: new TwoDimCellularAutomaton({width: 200, height: 100}),
      running: false,
      config: {
        aliveColor: '#000',
        deadColor: '#f7f4e3',
        density: 0.5,
        program: 'neighbors c sum 4 >',
      }
    }
  },
  computed: {
    program () {
      return this.config.program.toLowerCase().match(/\S+/g) || []
    }
  },
  provide () {
    return {
      automaton: this.automaton,
      config: this.config
    }
  },
  methods: {
    init () {
      this.automaton.initWorld({density: this.config.density})
    },
    run () {
      this.loop()
    },
    step () {
      this.automaton.oneStep()
    },
    loop () {
      this.step()
      this.running = window.requestAnimationFrame(this.loop)
    },
    stop () {
      if (this.running) {
        window.cancelAnimationFrame(this.running)
        this.running = false
      }
    },
    setRule () {
      this.automaton.setRule(this.program)
    }
  },
  mounted () {
    this.automaton.initWorld({density: this.config.desnity})
  }
}
</script>
<style lang="scss" scoped>
.dashboard /deep/ {
  width: 600px;
  margin: 0 auto;
  position: relative;
  #age {
    position: absolute;
    left: 5px;
    color: #777;
  }
  .code {
    .el-textarea__inner {
      background-color: #000;
      color: #8E8;
      font-family: Terminus,Consolas,Profont,"Andale Mono",Monaco,Inconsolata,Inconsolata-g,
      Unifont,Lime,"ClearlyU PUA",Clean,"DejaVu Sans Mono","Lucida Console",
      "Bitstream Vera Sans Mono",Freemono,"Liberation Mono",Dina,Anka,Droid Sans Mono,
      Anonymous Pro,Proggy fonts,Envy Code R,Gamow,Courier,"Courier New",Terminal,monospace;
      font-weight: bold;
    }
  }
}

</style>
